import React from 'react';
import { Box, Button, Text } from 'theme-ui';
import { Inline } from '@bedrock-layout/inline';
import { useHistory } from 'react-router';

function FormControls() {
  const history = useHistory();

  return (
    <Box variant="layout.header.form-controls" alignItems="center">
      <Inline gutter="md" align="start" stretch="start">
        <Text variant="section">Bulk Code Flags</Text>
        <Button variant="primary.text" onClick={() => history.push('/management')}>
          Back to tenants
        </Button>
      </Inline>
    </Box>
  );
}

export default FormControls;
